import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import {AuthService} from '../../../core/auth/auth.service';
import { UserService } from '../../../users/services/user.service';
import {TranslateService} from '@ngx-translate/core';
import { LocalStorageService } from '../../../core/local-storage/local-storage.service';
import { LocalStorageKeys } from '../../../core/local-storage/local-storage.enum';
import { LocaleEnum } from 'src/app/submit-lecture/lecture.values';
import { IUser } from 'src/app/users/interfaces/user.interface';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  currentUser: any;
  userInfo: IUser;
  photoChangedSubscription: Subscription;

  constructor(@Inject(DOCUMENT) private document: Document,
              private authService: AuthService,
              private userService: UserService,
              private router: Router,
              public translate: TranslateService,
              private localStorageService: LocalStorageService,
              private readonly toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.getUser();

    let lang: string = this.localStorageService.read(LocalStorageKeys.language);
    lang = lang ? lang : LocaleEnum.HE;
    this.translate.setDefaultLang(lang);
    this.changeLang(lang);

    this.photoChangedSubscription = this.userService.getPhotoUrlChanged().subscribe((data) => {
      this.getUser();
    });
  }

  ngOnDestroy(): void {
    this.photoChangedSubscription.unsubscribe();
  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(): void {
    this.document.body.classList.toggle('sidebar-open');
  }

  changeLang(lang): void {
    this.translate.use(lang);
    this.localStorageService.write(LocalStorageKeys.language, lang);

    switch (lang) {
      case LocaleEnum.EN:
        this.document.body.classList.remove('rtl');
        this.document.body.classList.add('ltr');
        break;
      case LocaleEnum.HE:
        this.document.body.classList.remove('ltr');
        this.document.body.classList.add('rtl');
        break;
    }
  }

  getUser(): void {
    this.getUserMetaData();
  }

  private getUserMetaData(): void {
    this.userService.getCurrentUserDetails().then((user: IUser) => {
      this.userInfo = user;
    }).catch((err) => {
      console.log(err);
      this.translate.get('GENERAL.ERROR').subscribe((text: string) => {this.toastr.error(text); });
    });
  }

  getDisplayName(): string {
    if (!this.userInfo || !this.userInfo.metadata) { return ''; }
    return this.userInfo.metadata.firstName ? this.userInfo.metadata.firstName + ' ' + this.userInfo.metadata.lastName :
      this.userInfo.displayName;
  }

  getEmail(): string {
    return this.userInfo && this.userInfo.metadata.email ? this.userInfo.metadata.email : '';
  }

  logout(): void {
    this.setLogout();
  }

  private setLogout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  editProfile(): void {}
}
